'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var claimStartedTemplate = function claimStartedTemplate(domain) {
  return {
    Destination: {
      ToAddresses: ['info@fishrmn.com']
    },
    Message: {
      Body: {
        Text: {
          Charset: 'UTF-8',
          Data: domain + ' has clicked claim and started the checkout process'
        }
      },
      Subject: {
        Charset: 'UTF-8',
        Data: 'Website Claim Started: ' + domain
      }
    },
    Source: 'websiteclaim@fishrmn.com'
  };
};

var claimExitedTemplate = function claimExitedTemplate(_ref) {
  var suggestedDomain = _ref.suggestedDomain,
      domainConfigurationChoice = _ref.domainConfigurationChoice,
      chosenDomain = _ref.chosenDomain,
      existingDomain = _ref.existingDomain;
  return {
    Destination: {
      ToAddresses: ['info@fishrmn.com']
    },
    Message: {
      Body: { /* required */
        Text: {
          Charset: 'UTF-8',
          Data: '\n        Status: Exited Claim Process\n        Fisherman Suggested Domain: ' + suggestedDomain + '\n        Domain Option Chosen: ' + domainConfigurationChoice + '\n        Chosen Domain: ' + chosenDomain + '\n        Existing Domain: ' + existingDomain + '\n        '
        }
      },
      Subject: {
        Charset: 'UTF-8',
        Data: 'Website Claim Exited: ' + suggestedDomain
      }
    },
    Source: 'websiteclaim@fishrmn.com'
  };
};

var claimCompleteTemplate = function claimCompleteTemplate(_ref2) {
  var suggestedDomain = _ref2.suggestedDomain,
      domainConfigurationChoice = _ref2.domainConfigurationChoice,
      chosenDomain = _ref2.chosenDomain,
      existingDomain = _ref2.existingDomain;
  return {
    Destination: {
      ToAddresses: ['info@fishrmn.com']
    },
    Message: {
      Body: { /* required */
        Text: {
          Charset: 'UTF-8',
          Data: '\n        Status: Completed Claim Process\n        Fisherman Suggested Domain: ' + suggestedDomain + '\n        Domain Option Chosen: ' + domainConfigurationChoice + '\n        Chosen Domain: ' + chosenDomain + '\n        Existing Domain: ' + existingDomain + '\n        '
        }
      },
      Subject: {
        Charset: 'UTF-8',
        Data: 'Website Claim Completed: ' + suggestedDomain
      }
    },
    Source: 'websiteclaim@fishrmn.com'
  };
};

var emailTemplateDictionary = {
  claimStarted: claimStartedTemplate,
  claimExited: claimExitedTemplate,
  claimCompleted: claimCompleteTemplate
};

exports.default = emailTemplateDictionary;